import UIDs from "../../../../UIDs";

const uid = UIDs.screens.account.teacherlogin;

const ActionTypes = {
    LOGIN_ASYNC: `${uid}.loginAsync`,
    LOGIN_SUCCESS: `${uid}.loginSuccess`,
    LOGIN_FAILURE: `${uid}.loginFailure`,

    TOGGLE_MODAL: `${uid}.toggleModal`,
    UPDATE_SETTINGS: `${uid}.updateSettings`,
};

export { ActionTypes };
